import { Plugin, toWidget, Widget } from "ckeditor5";
import { MediaType } from "../types";
import InsertMediaCommand, { getMediaModel } from "./InsertMediaCommand";

export default class VideoPlugin extends Plugin {
  static get requires() {
    return [Widget];
  }

  static get pluginName(): string {
    return "VideoPlugin";
  }

  init(): void {
    const { editor } = this;

    const mediaTypes = ["video", "audio"] as MediaType[];

    mediaTypes.forEach((type) => {
      const modelName = getMediaModel(type);

      editor.model.schema.register(modelName, {
        isObject: true,
        allowWhere: "$block",
        allowAttributes: ["src"],
      });

      editor.conversion.for("upcast").elementToElement({
        view: { name: type },
        model: (viewElement, { writer }) => {
          const src = viewElement.getAttribute("src");
          return writer.createElement(modelName, { src });
        },
      });

      editor.conversion.for("editingDowncast").elementToElement({
        model: modelName,
        view: (modelElement, { writer }) => {
          const src = modelElement.getAttribute("src");

          const mediaElement = writer.createContainerElement(type, {
            src,
            controls: "controls",
          });

          const figure = writer.createContainerElement("figure", {
            class: type,
          });

          writer.insert(writer.createPositionAt(figure, 0), mediaElement);

          return toWidget(figure, writer, {
            label: `${type} widget`,
          });
        },
      });

      editor.conversion.for("dataDowncast").elementToElement({
        model: modelName,
        view: (modelElement, { writer }) => {
          const src = modelElement.getAttribute("src");

          return writer.createContainerElement(type, {
            src,
            controls: "controls",
          });
        },
      });
    });

    editor.commands.add("insertVideo", new InsertMediaCommand(editor, MediaType.VIDEO));
    editor.commands.add("insertAudio", new InsertMediaCommand(editor, MediaType.AUDIO));
  }
}
